<template>
  <v-container>
    <v-row>
      <v-col v-for="(form, index) in orderInfo.portalForms" :key="index" cols="12">
        <PortalFormDetailCard
          :portal-form="form"
          :selected="orderInfo.portalSubmissionForm === form.description"
          @change-form-selection="emit('changeFormSelection', form.requestFormId)" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import PortalFormDetailCard from "@/components/PortalFormDetailCard.vue";

const props = defineProps({
  orderInfo: {
    type: Object,
    required: true,
  },
});

const orderInfo = ref(props.orderInfo);

const emit = defineEmits(["changeFormSelection"]);
</script>

<style lang="scss" scoped></style>
